import api from './axios';
import { API } from './links';

export interface CalibrationOption {
  value: string;
  label: string;
}

export interface CalibrationOptions {
  sensorType: CalibrationOption[];
  category: CalibrationOption[];
  displacementSensorType: CalibrationOption[];
  model: CalibrationOption[];
  range: CalibrationOption[];
}

export interface CalibrationOptionsParams {
  sensor_type?: string;
  category?: string;
  model_family?: string;
  model?: string;
  exclude_hidden_categories?: boolean;
}

/**
 * Fetches the combined options endpoint. Each collection narrows by the params that
 * apply to it, so callers read only the key they need (e.g. `.model`).
 */
export const fetchCalibrationOptions = async (params?: CalibrationOptionsParams): Promise<CalibrationOptions> =>
  (await api.get<CalibrationOptions>(API.calibrationForms.optionsCombined, { params })).data;
